/* Usage:
*  <uni-project-card-subtitle [project]="project" [contentType]="disciplines">
*  </uni-project-card-subtitle>
*/

import { Component, Input, OnInit } from '@angular/core';

import { Project } from '@sparro/app/core/models/project.model';

@Component({
  selector: 'uni-project-card-subtitle',
  templateUrl: './project-card-subtitle.component.html',
  styleUrls: ['./project-card-subtitle.component.scss']
})
export class ProjectCardSubtitleComponent implements OnInit {
  @Input() project: Project;
  @Input() truncate: boolean = false; // Will be deprecated soon

  constructor() { }

  ngOnInit(): void {
  }

}
